"use client";

import { cn } from "@/lib/utils";
import { CompactEmoji } from "emojibase";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

interface EmojiProps {
	items: CompactEmoji[];
	command: ({ id }: { id: string }) => void;
}

export default forwardRef((props: EmojiProps, ref) => {
	const [selectedIndex, setSelectedIndex] = useState(0);

	const selectItem = (index: number) => {
		const item = props.items[index];

		if (item) {
			const storedEmojis = localStorage.getItem("emojis");
			if (storedEmojis) {
				const emojis = JSON.parse(storedEmojis) as CompactEmoji[];
				emojis.unshift(item);

				localStorage.setItem("emojis", JSON.stringify(emojis.slice(0, 10)));
			} else {
				localStorage.setItem("emojis", JSON.stringify([item]));
			}
			props.command({ id: item.unicode });
		}
	};

	const upHandler = () => {
		setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
	};

	const downHandler = () => {
		setSelectedIndex((selectedIndex + 1) % props.items.length);
	};

	const enterHandler = () => {
		selectItem(selectedIndex);
	};

	useEffect(() => {
		setSelectedIndex(0);
	}, [props.items]);

	useImperativeHandle(ref, () => ({
		onKeyDown: ({ event }: { event: KeyboardEvent }) => {
			if (event.key === "ArrowLeft") {
				upHandler();
				return true;
			}

			if (event.key === "ArrowRight") {
				downHandler();
				return true;
			}

			if (event.key === "Enter") {
				enterHandler();
				return true;
			}

			return false;
		},
	}));

	if (props.items) {
		return (
			<div className="text-2x flex max-w-sm flex-row flex-wrap overflow-hidden rounded-md bg-gray-100 p-2 text-slate-700">
				{props.items.length ? (
					props.items.map((item, index) => (
						<button
							className={cn(
								"px-2 py-1",
								index === selectedIndex ? "rounded-md border border-gray-400" : ""
							)}
							key={index}
							onClick={() => selectItem(index)}
						>
							{item.unicode}
						</button>
					))
				) : (
					<div className="item">No result</div>
				)}
			</div>
		);
	}

	return null;
});
